import { NgModule } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  imports: [TranslocoModule]
})
export class AnimalSelectionTranslationsModule { }
